






























import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch, Emit } from "vue-property-decorator";
import { IHeader } from "@/store/models/staff/IHeader";
import { IVcClaimSummaryLightDto } from "@/asdcom/apiproxy/apiproxy.dto";

@Component
export default class ClaimListComponent extends BaseComponent {
  // @Prop({ default: () => false })

  @Prop({
    default: () => {
      return [];
    }
  })
  viewModel: IVcClaimSummaryLightDto[];

  get listData() {
    return this.viewModel;
  }

  private onListRowClick(item: IVcClaimSummaryLightDto) {
    // this.$emit("onItemClick", item.claimNumber);
    if (!!item.claimNumber && (item.claimNumber !== this.$route.params.claimNumber)) {
      this.$router.push({
        name: "ClaimSummary",
        params: { claimNumber: item.claimNumber }
      });
    } else {
      this.$emit("closeItemView");
    }
  }

  headers: IHeader[] = [
    { text: "Claim Number", value: "claimNumber", align: "center" },
    { text: "Submitted", value: "createdDate", align: "center" },
    { text: "Status", value: "claimStatus", align: "center" },
    { text: "Status Updated", value: "claimStatusDate", align: "center" },
    { text: "Assigned County", value: "assignedCountyName", align: "center" },
    {
      text: "Victim, Claimant, Crime Date",
      value: "claimSummary",
      align: "center",
      sortable: false
    }
  ];
}
